module.exports = __webpack_public_path__ + "images/menu-black_b21003453a5fb050f690845b9b8143f4.svg";